import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Confirm from '../confirm/Confirm';
import CustomerService from '../../service/CustomerService';
import { buildFailureStatus, buildSuccessStatus, } from '../constants/AlertConstants';
import FieldSet from '../fieldset/FieldSet';

class UpdateUsernameView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fromUsername: '',
      toUsername: '',
      open: false,
    };
  }

  componentDidMount() {
    const { requestedState, } = this.props;
    if (requestedState) {
      this.statefulInitialization(requestedState);
    }
  }

  onDismiss() {
    return () => {
      this.setState({
        status: null,
      });
    };
  }

  showConfirmation() {
    this.setState({
      open: true,
    });
  }

  closeConfirmation() {
    this.setState({
      open: false,
    });
  }

  statefulInitialization(customerProfile) {
    this.setState({
      fromUsername: customerProfile.username,
    });
  }

  submitUsernameChange({ fromUsername = '', toUsername = '', }) {
    this.setState({ isLoading: true, });
    CustomerService.updateUsername({
      fromUsername: fromUsername.toLowerCase().trim(),
      toUsername: toUsername.toLowerCase().trim(),
    })
      .then(() => {
        this.setState({
          status: buildSuccessStatus(
            `Username was successfully changed to:  ${toUsername}`,
            this.onDismiss()
          ),
        });
      })
      .catch(() => {
        this.setState({
          status: buildFailureStatus(
            `Unable to update username to: ${toUsername}`,
            this.onDismiss()
          ),
        });
      })
      .finally(() => {
        this.closeConfirmation();
        this.setState({ isLoading: false, });
      });
  }

  render() {
    const {
      fromUsername, toUsername, status, open, isLoading,
    } = this.state;

    const handleToUsernameChange = (event) => {
      const target = event.currentTarget;
      const value = target.value ? target.value : '';
      this.setState({ toUsername: value.toLowerCase().trim(), });
    };

    const handleFromUsernameChange = (event) => {
      const target = event.currentTarget;
      const value = target.value ? target.value : '';
      this.setState({ fromUsername: value.toLowerCase().trim(), });
    };

    return (
      <div className="container" style={{ marginTop: '50px', }}>
        <FieldSet>
          <input
            className="form-control"
            placeholder="Enter current username"
            defaultValue={fromUsername}
            onChange={handleFromUsernameChange}
          />
          <br />
          <div>
            <input
              className="form-control"
              placeholder="Enter new username"
              defaultValue={toUsername}
              onChange={handleToUsernameChange}
            />
          </div>
          <br />
          <Button variant="primary" onClick={() => this.showConfirmation()}>
            Update Username
          </Button>
          <Confirm
            isLoading={isLoading}
            title="Update Username Confirmation"
            content="Are you sure you want to update this username?"
            open={open}
            onClose={() => this.closeConfirmation()}
            onYes={() => this.submitUsernameChange({ fromUsername, toUsername, })}
            onNo={() => this.closeConfirmation()}
          />
        </FieldSet>
        {status}
      </div>
    );
  }
}

UpdateUsernameView.defaultProps = {
  requestedState: undefined,
};

UpdateUsernameView.propTypes = {
  requestedState: PropTypes.instanceOf(Object),
};

export default UpdateUsernameView;
